import React from "react";
import Style from '../Styles/Common.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const AboutMaadaddressComponent = ()=>{
    return(
        <div className={Style.mayogallerysec+"  "+Style.maadAddress}>
        <Container>
            <Row>
                <Col>
                    <div className={Style.addressinfo}style={{padding:"0px"}}>
                        <ul>
                            <li>Address : 508, 5th Floor, Akashdeep Building, Barakhamba Road, New Delhi - 110001, India</li>
                            <li className={Style.last}>Email: <a href="mailto:secretary@mayoalumni.in">secretary@mayoalumni.in</a></li>
                        </ul>
                        <ul>
                            <li>Phone no. : +91 - 11 - 23351880</li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
    )
}

export default AboutMaadaddressComponent;